<div class="background-checkout" [class.checkout-page]="isCheckoutPage">
  <router-outlet></router-outlet>
</div>
